import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import { SCORE_TYPE_AMOUNT, SCORE_TYPE_AVERAGE, SCORE_TYPE_MULTIPLIER, Section_Translated_Data } from './DynamicFormContext';
import { STATUS_PENDING, STATUS_APPROVAL_IN_PROGRESS, STATUS_APPROVAL_RETURN_TO_SUBMITTER } from '../Services/api/ActionItems';

import Utils from '../Services/Utils';
import NotificationService from '../Services/NotificationService';
import {
  checkConditions,
  getConditionValue,
  getConditionLabel,
  checkTriggerCondition
} from '../Services/ConditionalService';
import Attachments from '../Services/api/Attachments';
import ConfigService from '../Services/api/Config';
import WorkOrderTriggerService from '../Services/api/WorkOrderTriggerService';

import DynamicForm from '../Models/DynamicForm';
import Field from '../Models/Field';
import Section from '../Models/Section';
import FieldList from '../Models/FieldList';
import SectionList from '../Models/SectionList';
import FieldCondition from '../Models/FieldCondition';
import FieldConditionRule from '../Models/FieldConditionRule';
import WorkOrderModel from '../Models/WorkOrderModel';
import DynamicFormDataService from '../Services/api/DynamicFormData';
import TranslationService from '../Services/api/TranslationService';

const AutomaticFields = ['userName', 'propertyName', 'pmsPropertyId', 'propertyAddress', 'propertyInfo', 'unitNumber', 'unitBuilding', 'unitInfo', 'tenantId'];

const LfaContext = React.createContext(null);

export const Fields_With_OPTIONS = [
  'radio',
  'checkbox',
  'select',
  'ratingScale3pt'
]

export class LfaContextProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      clearing: false,
      loaded: false,
      configuration: null,
      fieldsData: null,
      fieldsTrigger: null,
      fieldsError: null,
      unit: null,
      task: null,
      property: null,
      status: null,
      filters: {},
      workOrderTabs: {},
      activeTab: 'Dynamic Form',
      user: null,
      modified: null,
      availableLanguages: [],
      tabs: [],
      formCreatedIn: 'en'
    };

    this.state.api = {
      init: this.init,
      getFieldData: this.getFieldData,
      onFieldValueChange: this.onFieldValueChange,
      onFieldErrorChange: this.onFieldErrorChange,
      onFieldTriggerChange: this.onFieldTriggerChange,
      onFieldErrorTriggerChange: this.onFieldErrorTriggerChange,
      onFieldPhotoChange: this.onFieldPhotoChange,
      onFieldNotesChange: this.onFieldNotesChange,
      onFieldWorkOrdersChange: this.onFieldWorkOrdersChange,
      getErrors: this.getErrors,
      convertToSaga: this.convertToSaga,
      getFirstError: this.getFirstError,
      checkLabelExist: this.checkLabelExist,
      onSectionCollapsed: this.onSectionCollapsed,
      onSaveCloneSection: this.onSaveCloneSection,
      onDeleteSectionCloned: this.onDeleteSectionCloned,
      getLabelGreatestSection: this.getLabelGreatestSection,
      setData: this.setData,
      clearData: this.clearData,
      setLoading: this.setLoading,
      getConfigurationCopy: this.getConfigurationCopy,
      onOpenCreateWorkOrderTabs: this.onOpenCreateWorkOrderTabs,
      onClickCreateNewWorkOrderTab: this.onClickCreateNewWorkOrderTab,
      onClickEditNewWorkOrderTab: this.onClickEditNewWorkOrderTab,
      onClickDeleteNewWorkOrderTab: this.onClickDeleteNewWorkOrderTab,
      onCloseWorkOrderTab: this.onCloseWorkOrderTab,
      onSetTab: this.onSetTab,
      onSetWorkOrderFormData: this.onSetWorkOrderFormData,
      replicateSaveProgress: this.replicateSaveProgress,
      saveDFChargeCodes: this.saveDFChargeCodes,
      getFieldsVerbiage : this.getFieldsVerbiage,
      onCompleteInLanguage : this.onCompleteInLanguage
    };
  }

  UNSAFE_componentWillMount() {
    ConfigService.initContextApi(this.state.api);
  }

  replicateSaveProgress = async (saveProgress) => {
    this.setState({
      saveProgress: saveProgress
    });
  };

  init = async (initData, availableLanguages, workOrdersTabsList) => {
    const { df, dfData, unit, property, user, task, status, filters, isFormBuilder, created_in_language } = initData;
    const {
      fieldsData,
      fieldsError,
      fieldsTrigger,
      configuration,
      workOrderTabs,
    } = await this._generateConfigurationAndData(
      df,
      dfData,
      unit,
      property,
      user,
      status,
      isFormBuilder,
      workOrdersTabsList
    );
    configuration.created_in_language = created_in_language;
    this.setState({
      clearing: false,
      fieldsData,
      fieldsError,
      fieldsTrigger,
      workOrderTabs,
      property,
      configuration,
      unit,
      task,
      status,
      user,
      filters,
      availableLanguages: availableLanguages
    });
    if(this.state.availableLanguages && this.state.availableLanguages.length > 0 && configuration.languages && configuration.languages.length > 0){
      let langCreated = df.created_in_language ? df.created_in_language : 'en';
      let createdInLang = this.state.availableLanguages.filter(lang => lang.code == langCreated);
      let langCodeArray = df.languages.map(lang => lang.code);
      if (!langCodeArray.includes(langCreated)) {
        this.setState({ tabs: [...createdInLang, ...df.languages], formCreatedIn: langCreated});
      }
      else {
        this.setState({ tabs: [...df.languages], formCreatedIn: langCreated});
      }
    }
  };

  setLoading = (loading) => {
    this.setState({ loading });
  };

  setData = (fieldsData) => {
    this.setState({ fieldsData });
  };

  clearData = (data) => {
    this.setState({
      clearing: true
    });
    this.init(data);
  };

  getFirstError = () => {
    const { fieldsData, fieldsError, configuration } = this.state;

    for (let i = 0; i < configuration.sections.order.length; i++) {
      const section = configuration.sections.items[configuration.sections.order[i]];
      if (fieldsData.sections[section.id].visibility) {
        for (let j = 0; j < section.fields.order.length; j++) {
          const field = section.fields.items[section.fields.order[j]];
          if (fieldsData.sections[section.id].fields[field.id].visibility && fieldsError.sections[section.id].fields[field.id]) {
            return {
              id: field.id,
              collapsed: fieldsData.sections[section.id].collapsed,
              sectionId: section.id
            };
          }
        }
      }
    }
  };

  getFieldData = (groupId) => {
    const { configuration } = this.state;
    let sectionId = null;
    let fieldId = null;
    configuration.sections.order.map((section) => {
      configuration.sections.items[section].fields.order.map((field) => {
        if (configuration.sections.items[section].fields.items[field].groupId === groupId) {
          sectionId = section;
          fieldId = field;
        }
      });
    });
    return {
      section: sectionId,
      id: fieldId
    };
  };

  onFieldValueChange = (sectionId, fieldId, value, newData, prevDepth) => {
    const { configuration, unit, property, user, loaded } = this.state;
    const depth = prevDepth ? prevDepth : 0;
    let fieldsData = newData ? newData : this.state.fieldsData;

    const sectionsToUpdate = [sectionId];

    // Sets values and error if present
    const fieldConfiguration = configuration.sections.items[sectionId].fields.items[fieldId];

    const fieldData = {
      ...fieldsData.sections[sectionId].fields[fieldId],
      value,
      score: !Utils.isNull(value) ? this._getFieldScore(fieldConfiguration, value) : null
      // error: fieldsData.sections[sectionId].fields[fieldId].error || error,
    };

    fieldsData.sections[sectionId].fields[fieldId] = fieldData;

    // Update visibility of affected fields and if hidden reset their value and score
    if (configuration.fields_visibility_hierarchy_reverse[fieldId]) {
      for (let i = 0; i < configuration.fields_visibility_hierarchy_reverse[fieldId].length; i++) {
        const affectedFieldId = configuration.fields_visibility_hierarchy_reverse[fieldId][i];
        const affectedFieldSectionId = configuration.field_section[affectedFieldId];
        let affectedFieldData = null;
        if (fieldsData.sections[affectedFieldId]) {
          affectedFieldData = fieldsData.sections[affectedFieldId];

          const visibility = this._getFieldVisibility(affectedFieldId, configuration, fieldsData);

          if (affectedFieldData && visibility !== affectedFieldData.visibility) {
            const newAffectedFieldData = {
              ...affectedFieldData,
              visibility: visibility
            };
            fieldsData.sections[affectedFieldId] = newAffectedFieldData;
            if (!sectionsToUpdate.includes(affectedFieldId)) sectionsToUpdate.push(affectedFieldId);
          }
        } else if (fieldsData.sections[affectedFieldSectionId]) {
          affectedFieldData = fieldsData.sections[affectedFieldSectionId].fields[affectedFieldId];

          const visibility = this._getFieldVisibility(affectedFieldId, configuration, fieldsData);

          if (affectedFieldData && visibility !== affectedFieldData.visibility) {
            const newAffectedFieldData = {
              ...affectedFieldData,
              visibility: visibility
            };

            if (!visibility) {
              newAffectedFieldData.value = null;
              newAffectedFieldData.score = null;
              if (depth < 10 && null !== affectedFieldData.value) {
                fieldsData = this.onFieldValueChange(affectedFieldSectionId, affectedFieldId, null, fieldsData, depth + 1);
              }
            } else {
              const affectedFieldConfiguration = configuration.sections.items[affectedFieldSectionId].fields.items[affectedFieldId];
              const defaultValue = this._getFieldDefaultValue(affectedFieldConfiguration, unit, property, user);
              if (!Utils.isNull(defaultValue)) {
                newAffectedFieldData.value = defaultValue;
                newAffectedFieldData.score = this._getFieldScore(affectedFieldConfiguration, defaultValue);
                if (depth < 20 && !Utils.isNull(defaultValue)) {
                  fieldsData = this.onFieldValueChange(affectedFieldSectionId, affectedFieldId, defaultValue, fieldsData, depth + 1);
                }
              }
            }

            fieldsData.sections[affectedFieldSectionId].fields[affectedFieldId] = newAffectedFieldData;

            if (!sectionsToUpdate.includes(affectedFieldSectionId)) sectionsToUpdate.push(affectedFieldSectionId);
          }
        }
      }
    }

    // Update value of affected fields and change their score
    if (configuration.fields_value_hierarchy_reverse[fieldId]) {
      for (let i = 0; i < configuration.fields_value_hierarchy_reverse[fieldId].length; i++) {
        const affectedFieldId = configuration.fields_value_hierarchy_reverse[fieldId][i];
        const affectedFieldSectionId = configuration.field_section[affectedFieldId];
        const affectedFieldConfig =
          configuration.sections.items[affectedFieldId] || configuration.sections.items[affectedFieldSectionId].fields.items[affectedFieldId];
        const affectedFieldData = fieldsData.sections[affectedFieldId] || fieldsData.sections[affectedFieldSectionId].fields[affectedFieldId];

        const { newValue, valueChanged } = this._getConditionalValue(fieldConfiguration, affectedFieldConfig, value);

        //Only call recursively if depth < 10
        if (depth < 10 && valueChanged && newValue !== affectedFieldData.value) {
          fieldsData = this.onFieldValueChange(affectedFieldSectionId, affectedFieldId, newValue, fieldsData, depth + 1);

          if (!sectionsToUpdate.includes(affectedFieldSectionId)) sectionsToUpdate.push(affectedFieldSectionId);
        }
      }
    }

    // Update section score and total score
    for (let i = 0; i < sectionsToUpdate.length; i++) {
      const sectionData = {
        ...fieldsData.sections[sectionsToUpdate[i]],
        score: this._getSectionScore(sectionsToUpdate[i], fieldsData, configuration)
      };

      fieldsData.sections[sectionsToUpdate[i]] = sectionData;
    }

    if (!loaded) {
      this.setState({
        loaded: true
      });
    }

    if (newData) return fieldsData;

    // Update section score and total score
    fieldsData.score = this._getTotalScore(fieldsData, configuration);
    this.setState({
      fieldsData,
      modified: new Date()
    });
  };

  onFieldErrorChange = (sectionId, fieldId, error) => {
    this.setState((prevState) => ({
      ...prevState,
      fieldsError: {
        ...prevState.fieldsError,
        sections: {
          ...prevState.fieldsError.sections,
          [sectionId]: {
            ...prevState.fieldsError.sections[sectionId],
            fields: {
              ...prevState.fieldsError.sections[sectionId].fields,
              [fieldId]: error
            }
          }
        }
      },
      modified: prevState.loaded ? new Date() : null
    }));
  };

  onFieldTriggerChange = (sectionId, fieldId, value) => {
    let fieldsData = this.state.fieldsData;
    const fieldData = {
      ...fieldsData.sections[sectionId].fields[fieldId],
      chargesTriggers: value,
    };

    fieldsData.sections[sectionId].fields[fieldId] = fieldData;
    this.setState((prevState) => ({
      fieldsData,
      modified: prevState.loaded ? new Date() : null
    }));
  }

  onFieldErrorTriggerChange = (sectionId, fieldId, error) => {
    this.setState((prevState) => ({
      ...prevState,
      fieldsError: {
        ...prevState.fieldsError,
        sections: {
          ...prevState.fieldsError.sections,
          [sectionId]: {
            ...prevState.fieldsError.sections[sectionId],
            fields: {
              ...prevState.fieldsError.sections[sectionId].fields,
              [fieldId + 'trigger']: error
            }
          }
        }
      },
      modified: new Date()
    }));
  };

  onFieldPhotoChange = (sectionId, fieldId, photo) => {
    const { fieldsData } = this.state;
    const sectionData = { ...fieldsData.sections[sectionId] };
    const fieldData = {
      ...fieldsData.sections[sectionId].fields[fieldId],
      photo: photo
    };
    sectionData.fields[fieldId] = fieldData;
    fieldsData.sections[sectionId] = sectionData;
    this.setState({ fieldsData, modified: new Date() });
  };

  onFieldNotesChange = (sectionId, fieldId, notes) => {
    const { fieldsData } = this.state;
    const sectionData = { ...fieldsData.sections[sectionId] };
    const fieldData = {
      ...fieldsData.sections[sectionId].fields[fieldId],
      notes: notes
    };
    sectionData.fields[fieldId] = fieldData;
    fieldsData.sections[sectionId] = sectionData;
    this.setState({ fieldsData, modified: new Date() });
  };

  onFieldWorkOrdersChange = (sectionId, fieldId, workOrderTriggers) => {
    const { fieldsData } = this.state;
    const sectionData = { ...fieldsData.sections[sectionId] };
    const fieldData = {
      ...fieldsData.sections[sectionId].fields[fieldId],
      workOrderTriggers: workOrderTriggers
    };
    sectionData.fields[fieldId] = fieldData;
    fieldsData.sections[sectionId] = sectionData;
    this.setState({ fieldsData, modified: new Date() });
  };

  onSectionCollapsed = (collapsed, sectionId) => {
    const { fieldsData } = this.state;

    this.setState({
      fieldsData: {
        ...fieldsData,
        sections: {
          ...fieldsData.sections,
          [sectionId]: {
            ...fieldsData.sections[sectionId],
            collapsed
          }
        }
      }
    });
  };

  getConfigurationCopy = () => {
    const { configuration } = this.state;

    const newConfig = new DynamicForm(configuration);

    const sections = {
      items: {},
      order: []
    };

    for (const sectionID of configuration.sections.order) {
      const fields = {
        items: {},
        order: []
      };
      const section = configuration.sections.items[sectionID];
      for (const fieldID of section.fields.order) {
        const field = section.fields.items[fieldID];
        fields.items[field.id] = new Field(field);
        fields.order.push(field.id);
      }
      const newSection = new Section(section);
      newSection.fields = new FieldList(fields);
      sections.items[section.id] = newSection;
      sections.order.push(section.id);
    }

    newConfig.sections = new SectionList(sections);
    return newConfig;
  };

  getErrors = () => {
    const { fieldsData, fieldsError, configuration } = this.state;

    const schemaSaga = configuration.serialize();
    const errorSaga = {};

    for (let i = 0; i < schemaSaga.fields.length; i++) {
      const section = schemaSaga.fields[i];
      if (fieldsData.sections[section.id].visibility) {
        for (let j = 0; j < section.children.length; j++) {
          const field = section.children[j];
          if (!Utils.isNull(fieldsError.sections[section.id].fields[field.id])) {
            errorSaga[field.id] = fieldsError.sections[section.id].fields[field.id];
          }
        }
      }
    }

    return errorSaga;
  };

  convertToSaga = async (skipLoading) => {
    const { fieldsData, fieldsError, configuration, task } = this.state;

    const schemaSaga = configuration.serialize();
    const dataSaga = {};
    const errorSaga = {};
    const groupIds = [];

    for (let i = 0; i < schemaSaga.fields.length; i++) {
      const section = schemaSaga.fields[i];
      if (fieldsData.sections[section.id].visibility) {
        dataSaga[section.id] = {
          score: fieldsData.sections[section.id].score
        };
        for (let j = 0; j < section.children.length; j++) {
          const field = section.children[j];
          if (
            fieldsData.sections[section.id].fields[field.id] &&
            (fieldsData.sections[section.id].fields[field.id].value !== null ||
              fieldsData.sections[section.id].fields[field.id].photo !== null ||
              fieldsData.sections[section.id].fields[field.id].notes !== null)
          ) {
            switch (field.component) {
              case 'fileImageInput':
              case 'fileInput':
              case 'imageInput':
              case 'imageMultipleInput':
                let files = null;
                if (fieldsData.sections[section.id].fields[field.id].value) {
                  files = [];
                  for (let k = 0; k < fieldsData.sections[section.id].fields[field.id].value.length; k++) {
                    const file = fieldsData.sections[section.id].fields[field.id].value[k];
                    if (file) {
                      const fileResult = file.id ? file : await Attachments.create([file], skipLoading);
                      if (fileResult) {
                        files.push(fileResult);
                      }
                    }
                  }
                }
                dataSaga[field.id] = {
                  value: files
                };
                break;
              case 'signatureInput':
                let fileResult = null;
                if (fieldsData.sections[section.id].fields[field.id].value) {
                  const signature = fieldsData.sections[section.id].fields[field.id].value;
                  if (signature) {
                    fileResult = signature.id ? signature : await Attachments.create([signature], skipLoading);
                  }
                }
                dataSaga[field.id] = {
                  value: fileResult
                };
                break;
              case 'checkbox':
              case 'checkboxJustifiedLeft':
                const value = fieldsData.sections[section.id].fields[field.id].value;
                let arrayValues = [];
                if (!Utils.isNull(value)) {
                  arrayValues = (Array.isArray(value) ? value : value.split(','));
                }

                const selectedOptions = field.options ? 
                arrayValues.map((item) => parseInt(item)).map(x => {
                    const option = field.options[x];
                    return option && option.id !== undefined ? option.id : null; // Check if option and option.id exist
                }).filter(optionId => optionId !== null) : [];


                if(selectedOptions && selectedOptions.length > 0){
                      dataSaga[field.id] = { value: arrayValues.map(item => parseInt(item)), optionId: selectedOptions };
                }else{
                  dataSaga[field.id] = {
                    value: arrayValues.map((item) => parseInt(item)),
                  };
                }

                break;
              default:
                const fieldValue = fieldsData.sections[section.id]?.fields[field.id]?.value;
                const optionValue = field.options?.[fieldValue];

                if(optionValue?.id){
                  dataSaga[field.id] = {
                    value: fieldValue,
                    optionId: optionValue?.id
                  };
                }else{
                  dataSaga[field.id] = {
                    value: fieldValue,
                  };
                }
                
                break;
            }
            if (!Utils.isNull(fieldsData.sections[section.id].fields[field.id].score)) {
              dataSaga[field.id]['score'] = fieldsData.sections[section.id].fields[field.id].score;
            }
            if (!Utils.isNull(fieldsData.sections[section.id].fields[field.id].notes)) {
              dataSaga[field.id]['notes'] = fieldsData.sections[section.id].fields[field.id].notes;
            }
            if (fieldsData.sections[section.id].fields[field.id].photo && fieldsData.sections[section.id].fields[field.id].photo.length) {
              let photos = [];
              for (let l = 0; l < fieldsData.sections[section.id].fields[field.id].photo.length; l++) {
                const photo = fieldsData.sections[section.id].fields[field.id].photo[l];
                const photoResult = photo.id ? photo : await Attachments.create([photo], skipLoading);
                photoResult.comment_active = photo.comment_active;
                photoResult.comment = photo.comment;
                photos.push(photoResult);
              }
              dataSaga[field.id]['photo'] = photos;
            }
          }
          if (!Utils.isNull(fieldsError.sections[section.id].fields[field.id])) {
            errorSaga[field.id] = fieldsError.sections[section.id].fields[field.id];
          }

          if (!groupIds.includes(field.groupId)) {
            groupIds.push(field.groupId);
          }
        }
      }
    }

    const scoreType =
      !Utils.isNull(configuration.scoreType) && !Utils.isNull(configuration.scoreType.value)
        ? configuration.scoreType.value
        : configuration.scoreType;

    return {
      id: fieldsData.id,
      dynamic_form: configuration.id,
      dynamic_form_score_type: scoreType,
      dynamic_form_name: configuration.name,
      dynamic_form_fields_triggers: configuration.dynamic_form_fields_triggers,
      score: fieldsData.score,
      uuid: fieldsData.uuid,
      dynamic_form_fields: schemaSaga.fields,
      data: dataSaga,
      errors: errorSaga,
      dynamic_form_fields_group_ids: groupIds.join(' '),
      action_item_id: task,
      images_layout: configuration.imagesLayout,
      created_in_language: configuration.created_in_language,
      locale: configuration.locale
    };
  };

  checkLabelExist = (label) => {
    const { configuration } = this.state;

    if (label) {
      const labelNewSection = label.split(' ').join('');
      const checkLabel = Object.values(configuration.sections.items).filter((section) => {
        const label = section.label ? section.label.split(' ').join('') : '';
        return labelNewSection === label;
      });

      if (checkLabel.length !== 0) {
        return 'This field can not be repeated.';
      }
    }
    return '';
  };

  onSaveCloneSection = (label, sectionId) => {
    if (this.checkLabelExist(label)) {
      return false;
    }

    this._onCloneSection(sectionId, label);
  };

  initializedLocaleInEachField = async (configuration) =>{
    if(configuration.locale && Object.keys(configuration.locale).length > 0){
      Object.keys(configuration.locale).forEach(key =>{
        configuration.sections.order.forEach(section =>{
          //  if locale is available then inserting locale fields in each field.
          configuration.sections.items[section][key] = {};
          Section_Translated_Data.forEach(translated_data =>{
            configuration.sections.items[section][key][translated_data] = configuration.locale[key][`${section}_${translated_data}`];
          })
          configuration.sections.items[section].fields.order.forEach(child =>{
            configuration.sections.items[section].fields.items[child][key] = {};
            Section_Translated_Data.forEach(translated_data =>{
              configuration.sections.items[section].fields.items[child][key][translated_data] = configuration.locale[key][`${child}_${translated_data}`];
              if(configuration.sections.items[section].fields.items[child] && configuration.sections.items[section].fields.items[child].options){
                configuration.sections.items[section].fields.items[child][key]['options'] = [];
                configuration.sections.items[section].fields.items[child].options.forEach((option, index)=>{
                   if(configuration.locale[key][`${child}_value-${index}`]){
                    let opt = {id : index, label: configuration.locale[key][`${child}_value-${index}`]}
                    configuration.sections.items[section].fields.items[child][key]['options'].push(opt);
                   }
                })
              }
            })
            
          })
        })
      })
    }
  }

  _generateConfigurationAndData = async (df, dfData, unit, property, user, actionItemStatus, isFormBuilder, workOrderTabs) => {
    const dfFields = dfData && dfData.dynamic_form_fields ? dfData.dynamic_form_fields : df.fields;
    const name = dfData && dfData.dynamic_form ? dfData.dynamic_form.name : df.name || '';
    if(!workOrderTabs){
      workOrderTabs = {};
    }


    if (![STATUS_PENDING, STATUS_APPROVAL_IN_PROGRESS, STATUS_APPROVAL_RETURN_TO_SUBMITTER].includes(actionItemStatus)) {
      df.disabled = true;
      dfFields.map((section) => {
        section.disabled = true;
        section.children.map((field) => {
          field.disabled = true;
        });
      });
    } else {
      df.disabled = false;
      dfFields.map((section) => {
        section.disabled = false;
        section.children.map((field) => {
          field.disabled = false;
        });
      });
    }

    const fieldsData = {
      id: dfData && dfData.id ? dfData.id : null,
      uuid: dfData && dfData.uuid ? dfData.uuid : Utils.generateUUID(),
      score: dfData ? dfData.score : 0,
      sections: {}
    };

    const fieldsError = {
      sections: {}
    };

    const fieldsTrigger = {
      sections: {},
    };

    const dfConfig = { ...df, name: name, fields: dfFields };

    const configuration = await DynamicForm.parse(dfConfig);
    if(dfData && dfData.locale && Object.keys(dfData.locale).length > 0){
       configuration.locale = dfData.locale
    }
    await this.initializedLocaleInEachField(configuration)
    configuration.fields_visibility_hierarchy = {};
    configuration.fields_visibility_hierarchy_reverse = {};
    configuration.fields_value_hierarchy_reverse = {};
    configuration.field_section = {};
    configuration.dynamic_form_fields_triggers = df.dynamic_form_fields_triggers || null;
    const triggerDictionary = dfData?.trigger_data || {};

    Object.keys(configuration.sections.items).forEach((sectionId) => {
      const section = configuration.sections.items[sectionId];
      const scoreType = !Utils.isNull(section.scoreType) && !Utils.isNull(section.scoreType.value) ? section.scoreType.value : section.scoreType;
      const sectionScoreDefaultValue = scoreType ? 0 : null;

      const sectionData = {
        score: dfData && dfData.data && dfData.data[section.id] ? dfData.data[section.id].score : sectionScoreDefaultValue,
        fields: {},
        collapsed: false,
        visibility: true
      };

      const sectionErrors = {
        fields: {}
      };

      const sectionTriggers = {
        fields: {},
      };

      // We build the fields_visibility_hierarchy to sections
      if (section.conditions && section.conditions.length > 0) {
        const { hierarchy, hierarchyReverse } = this._buildFieldsVisibilityHierarchy(
          section,
          configuration.fields_visibility_hierarchy,
          configuration.fields_visibility_hierarchy_reverse
        );
        configuration.fields_visibility_hierarchy = hierarchy;
        configuration.fields_visibility_hierarchy_reverse = hierarchyReverse;
      }

      Object.keys(section.fields.items).forEach((fieldId) => {
        const field = section.fields.items[fieldId];

        configuration.field_section[field.id] = field.section;

        const triggersField = triggerDictionary[field.groupId] || {};
        const { triggers } = field;

        let workOrderTriggers = {};
        let chargesTriggers = [];

        for (let [key, value] of Object.entries(triggersField)) {
          if (value.work_orders) {
            workOrderTriggers[key] = value;
          }
          if (value.charge) {
            if (triggers && !Utils.isNull(value)) {
              triggers.map((trigger) => {
                if (trigger.id === key) {
                  trigger.amount = value.charge.amount;
                  trigger.comment = value.charge.comment;
                  chargesTriggers.push(trigger);
                }
              });
            }
          }
        }

        const dataField = dfData && dfData.data ? dfData.data[field.id] : null;
        const errorField = dfData && dfData.errors ? dfData.errors[field.id] : null;

        const fieldData = {
          score: dataField ? dataField.score : null,
          value: dataField && !Utils.isNull(dataField.value) ? dataField.value : null,
          photo: dataField ? dataField.photo : null,
          notes: dataField ? dataField.notes : null,
          visibility: dataField && !Utils.isNull(dataField.visibility) ? Boolean(dataField.visibility) : true,
          workOrderTriggers: workOrderTriggers,
          chargesTriggers: chargesTriggers
        };

        const defaultValue = this._getFieldDefaultValue(field, unit, property, user);
        if (actionItemStatus === 0 || isFormBuilder) {
          if (defaultValue !== null && fieldData.value === null) {
            fieldData.value = (Utils.isNull(fieldsData.id) || this.state.clearing) ? defaultValue : ((Utils.isNull(fieldData.value) ? defaultValue : fieldData.value) );
          }
        } else {
          if (AutomaticFields.includes(field.component)) {
            fieldData.value = fieldData.value || ' - ';
          }
        }

        fieldData.score = !Utils.isNull(fieldData.value) ? this._getFieldScore(field, fieldData.value) : null

        // We build the fields_visibility_hierarchy to fields
        if (field.conditions && field.conditions.length > 0) {
          const { hierarchy, hierarchyReverse } = this._buildFieldsVisibilityHierarchy(
            field,
            configuration.fields_visibility_hierarchy,
            configuration.fields_visibility_hierarchy_reverse
          );
          configuration.fields_visibility_hierarchy = hierarchy;
          configuration.fields_visibility_hierarchy_reverse = hierarchyReverse;
        }

        // We build the fields_value_hierarchy
        if (field.conditionsRules && field.conditionsRules.length > 0) {
          configuration.fields_value_hierarchy_reverse = this._buildFieldsValueHierarchyReverse(field, configuration.fields_value_hierarchy_reverse);
        }

        sectionData.fields[field.id] = fieldData;
        sectionErrors.fields[field.id] = errorField || null;
        sectionTriggers.fields[field.id] = chargesTriggers;
        return [ sectionData, sectionErrors, sectionTriggers ];
      });

      fieldsData.sections[section.id] = sectionData;
      fieldsError.sections[section.id] = sectionErrors;
      fieldsTrigger.sections[section.id] = sectionTriggers;
      return [ fieldsData, fieldsError, fieldsTrigger ];
    });

    // We set the visibility once we have the values set
    const fvh_keys = Object.keys(configuration.fields_visibility_hierarchy);

    for (let i = 0; i < fvh_keys.length; i++) {
      const fieldId = fvh_keys[i];
      if (fieldsData.sections[fieldId]) {
        fieldsData.sections[fieldId].visibility = this._getFieldVisibility(fieldId, configuration, fieldsData);
      } else {
        const sectionId = configuration.field_section[fieldId];
        fieldsData.sections[sectionId].fields[fieldId].visibility = this._getFieldVisibility(fieldId, configuration, fieldsData);
      }
    }

    // Update section score and total score
    configuration.sections.order.map((sectionId) => {
      const sectionData = fieldsData.sections[sectionId];
      configuration.sections.items[sectionId].fields.order.map((fieldId) => {
        const field = configuration.sections.items[sectionId].fields.items[fieldId];
        const fieldData = fieldsData.sections[sectionId].fields[fieldId];
        if (fieldData.value !== null && (!fieldData.visibility || !sectionData.visibility)) {
          fieldData.score = 0;
          if (AutomaticFields.includes(field.component)) {
            fieldData.value = fieldData.value;
          }
          else{
            fieldData.value = Utils.isNull(fieldData.value) ? null : fieldData.value;
          }
        }
      });
      fieldsData.sections[sectionId].score = this._getSectionScore(sectionId, fieldsData, configuration);
    });
    fieldsData.score = this._getTotalScore(fieldsData, configuration);

    return {
      fieldsData,
      fieldsError,
      fieldsTrigger,
      configuration,
      workOrderTabs
    };
  };

  _buildFieldsVisibilityHierarchy(field, hierarchy, hierarchyReverse) {
    hierarchy[field.id] = [];
    for (let k = 0; k < field.conditions.length; k++) {
      const condition = field.conditions[k];
      hierarchy[field.id].push({
        ...condition
      });
      const conditionField = condition.conditionField && condition.conditionField.value ? condition.conditionField.value : condition.conditionField;

      if (hierarchyReverse.hasOwnProperty(conditionField) !== true) {
        hierarchyReverse[conditionField] = [];
      }
      hierarchyReverse[conditionField].push(field.id);
    }
    return { hierarchy, hierarchyReverse };
  }

  _buildFieldsValueHierarchyReverse(field, hierarchy) {
    for (let k = 0; k < field.conditionsRules.length; k++) {
      const conditionRule = field.conditionsRules[k];
      const conditionField =
        conditionRule.conditionField && conditionRule.conditionField.value ? conditionRule.conditionField.value : conditionRule.conditionField;

      if (hierarchy.hasOwnProperty(conditionField) !== true) {
        hierarchy[conditionField] = [];
      }
      hierarchy[conditionField].push(field.id);
    }

    return hierarchy;
  }

  _getFieldVisibility(fieldId, configuration, fieldsData) {
    const conditions = configuration.fields_visibility_hierarchy[fieldId];
    if (!conditions || conditions.length === 0) {
      return true;
    }

    const conditionFields = conditions.map(condition =>
      condition.conditionField?.value ?? condition.conditionField
    );

    const isSameField = conditionFields.every(field => field === conditionFields[0]);
    const conditionField = conditionFields[0];

    const getFieldContext = (fieldId) => {
      const sectionId = configuration.field_section[fieldId];
      if (!sectionId) {
        return null;
      }
      const fieldConfiguration = configuration.sections.items[sectionId].fields.items[fieldId];
      const value = fieldsData.sections[sectionId]?.fields[fieldId]?.value;
      if (value == null) {
        return null;
      }
      return { sectionId, fieldConfiguration, value };
    };

    if (isSameField && conditions.length > 1) {
      const context = getFieldContext(conditionField);
      if (!context) {
        return false;
      }

      const anyConditionMet = conditions.some(condition =>
        this._checkFieldCondition(condition, context.fieldConfiguration, context.value)
      );

      return anyConditionMet;
    }

    for (let i = 0; i < conditions.length; i++) {
      const condition = conditions[i];
      const condField = condition.conditionField?.value ?? condition.conditionField;

      const context = getFieldContext(condField);
      if (!context) {
        return false;
      }

      const isOK = this._checkFieldCondition(condition, context.fieldConfiguration, context.value);
      if (!isOK) {
        return false;
      }
    }

    return true;
  }

  _getFieldDefaultValue(field, unit, property, user) {
    let results = null;
    switch (field.component) {
      case 'userName':
        return user ? [user.first_name, user.last_name].join(' ') : '';
      case 'propertyName':
        return property && property.name ? property.name : '';
      case 'pmsPropertyId':
        return property && property.pms_external_id ? property.pms_external_id : '';
      case 'propertyAddress':
        return property && property.fields.property_complete_address ? property.fields.property_complete_address : '';
      case 'propertyInfo':
        return property && property.fields && field.config && property.fields[field.config.field] ? property.fields[field.config.field] : '';
      case 'unitNumber':
        return unit && unit.number ? unit.number : '';
      case 'unitBuilding':
        return unit && unit.building ? unit.building : '';
      case 'unitInfo':
        if (field.config) {
          if (unit && (unit[field.config.field] || unit[field.config.field] === 0)) {
            return field.config.field === 'unit_type' ? unit[field.config.field].name : unit[field.config.field];
          }
        }
        return 'N/A';
      case 'tenantId':
        return unit && unit.resident_id ? unit.resident_id : '';  
      case 'fileEmbedded':
        return Array.isArray(field.embedded) ? field.embedded[0] : '';
      case 'checkbox':
        if (!Utils.isNull(field.defaultValue)) {
          results = [];
          const defaultValue = !Utils.isNull(field.defaultValue.value) ? field.defaultValue.value : field.defaultValue;
          const value = !Array.isArray(defaultValue) ? defaultValue.split(',') : defaultValue;
          field.options.forEach((item, key) => {
            if ((value.includes(key) || (value.includes(key.toString())) )) {
              results.push(key.toString());
            }
            else if (value.includes(item.value)) {
              results.push(key.toString());
            }
          });
        }
        return results;
      case 'radio':
      case 'select':
      case 'ratingScale3pt':
        if (!Utils.isNull(field.defaultValue)) {
          const defaultValue = !Utils.isNull(field.defaultValue.value) ? field.defaultValue.value : field.defaultValue;
          const value = Array.isArray(defaultValue) ? defaultValue.join(',') : defaultValue;
          field.options.map((item, key) => {
            if ((key == value)|| (item.value == value)) {
              results = key;
            }
          });
        }
        return results;
    }
    return null;
  }

  _getConditionalValue = (fieldConfig, affectedFieldConfig, value) => {
    let valueChanged = false;
    for (let i = 0; i < affectedFieldConfig.conditionsRules.length; i++) {
      const condition = affectedFieldConfig.conditionsRules[i];
      const conditionField = condition.conditionField && condition.conditionField.value ? condition.conditionField.value : condition.conditionField;
      const ruleValue = getConditionValue(condition.ruleValue);

      if (conditionField === fieldConfig.id) {
        if (this._checkFieldCondition(condition, fieldConfig, value)) {
          return {
            newValue: this._getComponentValue(affectedFieldConfig, ruleValue),
            valueChanged: true
          };
        }
      }
    }
    return {
      newValue: null,
      valueChanged
    };
  };

  _getComponentValue = (fieldConfiguration, value) => {
    // radio
    if (fieldConfiguration.component.includes('radio') || fieldConfiguration.component === 'select') {
      //We make sure value index exist
      return fieldConfiguration.options.length > value ? parseInt(value) : null;
    }
    // other
    return value;
  };

  _checkFieldCondition = (condition, fieldConfiguration, value) => {
    let isOK = null;
    const conditionValue = getConditionValue(condition.conditionValue);
    const conditionType = condition.conditionType && condition.conditionType.value ? condition.conditionType.value : condition.conditionType;
    const { component } = fieldConfiguration;

    if (component.includes('checkbox')) {
      let val = null;
      if (Array.isArray(value)) {
        val = value;
      }
      else {
        val = (!Utils.isNull(value) ? value.split(',') : []);
      }
      if (val.length > 0) {
        const valueOptions = [];
        val.sort().map((item) => {
          if (fieldConfiguration.options[item]) {
            valueOptions.push(fieldConfiguration.options[item].value);
          }
        });
        const parseConditionValue = Array.isArray(conditionValue) ? conditionValue : [conditionValue];
        const valueToCompare = [];
        fieldConfiguration.options.map((item) => {
          if (parseConditionValue.includes(item.value)) {
            valueToCompare.push(item.value);
          }
        });
        isOK = checkConditions(conditionType, valueToCompare, valueOptions, component);
        if (isOK) return true;
      }
    }
    // select | radio
    else if (component === 'select' || component.includes('radio')) {
      let v = fieldConfiguration.options[value] && fieldConfiguration.options[value].value ? fieldConfiguration.options[value].value : null;
      isOK = checkConditions(conditionType, conditionValue, v, component);
      if (isOK) return true;
    }
    // currencyInput
    else if (component === 'currencyInput') {
      if (typeof value === 'string' && value.includes('$')) {
        isOK = checkConditions(conditionType, conditionValue, parseFloat(value.substring(1, value.length)), component);
        if (isOK) return true;
      }
      else {
        isOK = checkConditions(conditionType, conditionValue, value, component);
        if (isOK) return true;
      }
    }
    //date
    else if (component === 'dateTimeInput') {
      const date1 = Utils.formatDateTime(new Date(conditionValue));
      const date2 = Utils.formatDateTime(new Date(value));

      isOK = checkConditions(conditionType, date1, date2, component);
      if (isOK) return true;
    } else if (component === 'dateInput') {
      const date1 = Utils.formatDate(new Date(conditionValue));
      const date2 = Utils.formatDate(new Date(value));

      isOK = checkConditions(conditionType, date1, date2, component);
      if (isOK) return true;
    } else if (component === 'timeInput') {
      const date1 = Utils.formatTime(new Date(conditionValue));
      const date2 = Utils.formatTime(new Date(value));

      isOK = checkConditions(conditionType, date1, date2, component);
      if (isOK) return true;
    }
    // other
    else {
      isOK = checkConditions(conditionType, conditionValue, value, component);
      if (isOK) return true;
    }
    return false;
  };

  _getFieldScore = (fieldConfiguration, value) => {
    const scoreType =
      !Utils.isNull(fieldConfiguration.scoreType) && !Utils.isNull(fieldConfiguration.scoreType.value)
        ? fieldConfiguration.scoreType.value
        : fieldConfiguration.scoreType;
    if (!scoreType) return null;
    if (!Utils.isNull(value)) {
      switch (fieldConfiguration.component) {
        case 'numberInput':
          if (!Utils.isNull(fieldConfiguration.scoreType) && fieldConfiguration.scoreType.value === SCORE_TYPE_AMOUNT) {
            return parseFloat(fieldConfiguration.score);
          }
          if (!Utils.isNull(fieldConfiguration.scoreType) && fieldConfiguration.scoreType.value === SCORE_TYPE_MULTIPLIER) {
            return parseFloat(fieldConfiguration.multiplierScore) * parseFloat(value);
          }
          return null;
        case 'starRate':
        case 'sliderRange':
          return parseFloat(value);
        case 'currencyInput':
          if (typeof value === 'string' && value.includes('$')) {
            return parseFloat(value.substring(1, value.length));
          } else {
            return parseFloat(value);
          }
        case 'radio':
        case 'radioJustifiedLeft':
        case 'select':
        case 'ratingScale3pt':
          const scoreValue =
            !Utils.isNull(fieldConfiguration.options[value]) && !Utils.isNull(fieldConfiguration.options[value].score)
              ? fieldConfiguration.options[value].score
              : null;
          return scoreValue ? parseFloat(scoreValue) : null;
        case 'checkbox':
        case 'checkboxJustifiedLeft':
          value = Array.isArray(value) ? value : value.split(',');
          let score = null;
          let elements = 0;
          let optionScore = null;

          for (let i = 0; i < value.length; i++) {
            optionScore = null;
            if (!Utils.isNull(fieldConfiguration.options[value[i]])) {
              if (!Utils.isNull(fieldConfiguration.options[value[i]].score)) {
                optionScore = fieldConfiguration.options[value[i]].score;
                elements++;
              }
            }
            if (!Utils.isNull(optionScore)) {
              score += parseFloat(parseFloat(optionScore).toFixed(2));
            }
          }

          if (scoreType === SCORE_TYPE_AVERAGE && !Utils.isNull(score) && elements > 0) {
            score = score / elements;
            if (!Number.isInteger(score)) score = parseFloat(parseFloat(score).toFixed(2));
          }

          return score;
        case 'timeInput':
          let minuteTime = 0;
          let dataTime = value.split(':');
          minuteTime = parseInt(dataTime[0] * 60) + parseInt(dataTime[1]);
          return parseInt(minuteTime);
        default:
          return null;
      }
    }
    return null;
  };

  _getSectionScore = (sectionId, fieldsData, configuration) => {
    const sectionConfig = configuration.sections.items[sectionId];
    const sectionData = fieldsData.sections[sectionId];
    const scoreType =
      !Utils.isNull(sectionConfig.scoreType) && !Utils.isNull(sectionConfig.scoreType.value)
        ? sectionConfig.scoreType.value
        : sectionConfig.scoreType;

    if (!scoreType || !sectionData.visibility) return null;

    let score = 0;
    let childrenCount = 0;

    for (let i = 0; i < sectionConfig.fields.order.length; i++) {
      const itemScore = fieldsData.sections[sectionId].fields[sectionConfig.fields.order[i]].score;
      if (!Utils.isNull(itemScore)) {
        childrenCount++;
        score += parseFloat(parseFloat(itemScore).toFixed(2));
      }
    }

    if (scoreType === SCORE_TYPE_AVERAGE && childrenCount > 0) {
      score = score / childrenCount;
    }

    if (!Number.isInteger(score)) score = parseFloat(parseFloat(score).toFixed(2));

    return childrenCount == 0 ? null : score;
  };

  _getTotalScore = (fieldsData, configuration) => {
    const scoreType =
      !Utils.isNull(configuration.scoreType) && !Utils.isNull(configuration.scoreType.value)
        ? configuration.scoreType.value
        : configuration.scoreType;

    if (!scoreType) return null;

    let score = 0;
    let childrenCount = 0;

    for (let i = 0; i < configuration.sections.order.length; i++) {
      const sectionScore = fieldsData.sections[configuration.sections.order[i]].score;
      if (!Utils.isNull(sectionScore)) {
        childrenCount++;
        score += parseFloat(parseFloat(sectionScore).toFixed(2));
      }
    }

    if (scoreType === SCORE_TYPE_AVERAGE && childrenCount > 0) {
      score = score / childrenCount;
    }

    if (!Number.isInteger(score)) score = parseFloat(parseFloat(score).toFixed(2));

    return score;
  };
  
  updateExistingForm = async (field) => {
    const {configuration} = this.state;
    if(this.state.availableLanguages && this.state.availableLanguages.length > 0){
      if (configuration.locale && Object.keys(configuration.locale).length > 0) {
        let fieldContext = { id: field.id }
        Section_Translated_Data.forEach(translated_data => {
          fieldContext[translated_data] = field[translated_data];
        })
        if (Fields_With_OPTIONS.includes(field.component)) {
          fieldContext['options'] = field['options'];
        }
        let context = fieldContext;
        let translate_lang = Object.keys(configuration.locale);
        let request = {
          original_lang: this.state.formCreatedIn,
          translate_lang: (translate_lang && translate_lang.length > 0) ? translate_lang : ['en'],
          context: context
        }
        this.setLoading(true);
        await TranslationService.getTranslations(request).then(res => {
          if (res && res.context && Object.keys(res.context).length > 0) {
            // for single field at a time
              res.context.forEach(translated_data => {
                translated_data.forEach(loc => {
                  Object.keys(loc).forEach(lang_code => {
                    Section_Translated_Data.forEach(translated_field => {
                      configuration.locale[lang_code][`${loc[lang_code].id}_${translated_field}`] = loc[lang_code][translated_field];
                    })
                    if (loc[lang_code]['options'] && loc[lang_code]['options'].length > 0) {
                      loc[lang_code]['options'].forEach((option, index) => {
                        configuration.locale[lang_code][`${loc[lang_code].id}_value-${index}`] = option.value;
                      })
                    }
                  })
                })
              })
          }
          this.setState({
            configuration: {...configuration},
            loading: false
          });

        }).catch(err => {
          this.setLoading(false);
          error = true
        });
      }
    }
   
  }

  _onCloneSection = async (sectionId, label) => {
    const { configuration, fieldsData, fieldsError } = this.state;

    let oldSection = new Section(configuration.sections.items[sectionId]);
    let originId = oldSection.originId || oldSection.id;
    let newSectionId;
    let greatestSectionId = 0;

    for (let i = 0; i < configuration.sections.order.length; i++) {
      let splitElement = configuration.sections.order[i].split('#');

      if (splitElement.length > 1) {
        if (greatestSectionId < parseInt(splitElement[1])) {
          greatestSectionId = parseInt(splitElement[1]);
        }
      }
    }

    //Generate new id for the new section
    greatestSectionId += 1;
    newSectionId = 'sectionDivider' + '#' + greatestSectionId;

    if (oldSection) {
      if (!label) {
        //Create new label if the name doesn't exist
        label = this.getLabelGreatestSection(sectionId);
      }
      //Generate section fields
      let fields = this._generateItems(oldSection, newSectionId, label);

      let newSection = new Section({
        ...oldSection,
        originId,
        label,
        id: newSectionId,
        fields
      });

      //Generate new fieldsData
      const { sectionData, sectionErrors } = this._generateNewDataSection(fields, oldSection.id);
      fieldsData.sections[newSectionId] = sectionData;
      fieldsError.sections[newSectionId] = sectionErrors;

      // We build the fields_visibility_hierarchy
      if (newSection.conditions && newSection.conditions.length > 0) {
        const { hierarchy, hierarchyReverse } = this._buildFieldsVisibilityHierarchy(
          newSection,
          configuration.fields_visibility_hierarchy,
          configuration.fields_visibility_hierarchy_reverse
        );
        configuration.fields_visibility_hierarchy = hierarchy;
        configuration.fields_visibility_hierarchy_reverse = hierarchyReverse;
        fieldsData.sections[newSectionId].visibility = this._getFieldVisibility(newSectionId, configuration, fieldsData);
      }

      //Update section order
      configuration.sections.order = this._insertChild(configuration.sections.order, newSectionId, oldSection.id);
      configuration.sections.items[newSectionId] = newSection;

      //update conditional hierarchies
      Object.values(newSection.fields.items).forEach((field) => {
        configuration.field_section[field.id] = newSectionId;

        // We build the fields_visibility_hierarchy to fields
        if (field.conditions && field.conditions.length > 0) {
          const { hierarchy, hierarchyReverse } = this._buildFieldsVisibilityHierarchy(
            field,
            configuration.fields_visibility_hierarchy,
            configuration.fields_visibility_hierarchy_reverse
          );
          configuration.fields_visibility_hierarchy = hierarchy;
          configuration.fields_visibility_hierarchy_reverse = hierarchyReverse;
          fieldsData.sections[newSectionId].fields[field.id].visibility = this._getFieldVisibility(field.id, configuration, fieldsData);
        }

        // We build the fields_value_hierarchy
        if (field.conditionsRules && field.conditionsRules.length > 0) {
          configuration.fields_value_hierarchy_reverse = this._buildFieldsValueHierarchyReverse(field, configuration.fields_value_hierarchy_reverse);
        }
      });

      // implementing translations4
      await this.updateExistingForm(configuration.sections.items[newSectionId]);
        if(this.state.availableLanguages && this.state.availableLanguages.length > 0 && configuration.locale && Object.keys(configuration.locale).length > 0){
          Object.keys(configuration.locale).forEach(lang_code =>{
            Object.keys(newSection.fields['items']).forEach(field =>{
              Object.keys(oldSection.fields['items']).forEach(oldfield =>{
                Section_Translated_Data.forEach(translated_field => {
                  configuration.locale[lang_code][`${field}_${translated_field}`] = configuration.locale[lang_code][`${oldfield}_${translated_field}`];
                })
                if (oldSection.fields['items'][oldfield] && oldSection.fields['items'][oldfield]['options'] && oldSection.fields['items'][oldfield]['options'].length > 0) {
                  oldSection.fields['items'][oldfield]['options'].forEach((option, index) => {
                    configuration.locale[lang_code][`${field}_value-${index}`] = configuration.locale[lang_code][`${oldfield}_value-${index}`]
                  })
                }
              })
            })
          })
        }
      // update locale in each fields
      await this.initializedLocaleInEachField(configuration)

      this.setState({
        configuration,
        fieldsData
      });
    }
  };

  getLabelGreatestSection = (sectionId) => {
    const { configuration } = this.state;

    const sectionFields = Object.values(configuration.sections.items);
    let maxNumber = 0;
    let label = configuration.sections.items[sectionId].label.split(' ');
    let check = false;

    if (parseFloat(label[label.length - 1])) {
      label.pop();
    }

    label = label.join(' ');

    sectionFields.forEach((element) => {
      let labelElement = element.label ? element.label.split(' ') : [];
      let labelElementWithOutLast = 0;

      if (labelElement.length > 0) {
        if (parseFloat(labelElement[labelElement.length - 1])) {
          labelElementWithOutLast = labelElement.pop();
        }
      }

      if (Array.isArray(labelElement)) {
        labelElement = labelElement.join(' ');
      }

      if (label === labelElement) {
        check = true;
        if (parseFloat(labelElementWithOutLast) > maxNumber) {
          maxNumber = parseFloat(labelElementWithOutLast);
        }
      }
    });

    if (!maxNumber && check) {
      maxNumber = 2;
      return label + ' ' + maxNumber.toString();
    }

    maxNumber++;
    return label + ' ' + maxNumber.toString();
  };

  _generateItems = (oldSection, idSection, labelSection) => {
    const { configuration } = this.state;

    let count = 0;
    let items = {};
    let order = [];

    Object.values(oldSection.fields.items).forEach((child) => {
      let sameChildren = [];
      let greatestId = 0;
      Object.values(configuration.sections.items).forEach((section) => {
        Object.values(section.fields.items).forEach((element) => element.component === child.component && sameChildren.push(element));
      });
      sameChildren.forEach((sameElement) => {
        let splitElement = sameElement.id.split('#');
        if (splitElement.length > 1) {
          if (greatestId < parseInt(splitElement[1])) {
            greatestId = parseInt(splitElement[1]);
          }
        }
        return greatestId;
      });
      count++;
      greatestId += 1 + count;
      order.push(child.component + '#' + greatestId);
      const sectionOriginId = oldSection.originId || oldSection.id;
      const originId = child.originId || child.id;
      items = {
        ...items,
        [child.component + '#' + greatestId]: new Field({
          ...child,
          originId: originId,
          id: child.component + '#' + greatestId,
          section: idSection,
          groupId: Utils.generateGroupId(labelSection, sectionOriginId, originId)
        })
      };
    });
    Object.values(items).forEach((child) => {
      let conditions = null;
      let conditionsRules = null;
      if (child.conditions && child.conditions.length > 0) {
        conditions = [];
        child.conditions.map((condition) => {
          const conditionField =
            condition.conditionField && condition.conditionField.value ? condition.conditionField.value : condition.conditionField;
          let conditionOriginId = null;

          Object.values(oldSection.fields.items).forEach((element) => {
            if (conditionField === element.id) {
              conditionOriginId = element.originId || element.id;
            }
          });

          if (conditionOriginId) {
            Object.values(items).forEach((element) => {
              if (conditionOriginId === element.originId) {
                conditions.push(new FieldCondition({ ...condition, conditionField: { value: element.id, label: element.label } }));
              }
            });
          } else {
            conditions.push(new FieldCondition({ ...condition }));
          }
        });
      }
      if (child.conditionsRules && child.conditionsRules.length > 0) {
        conditionsRules = [];
        child.conditionsRules.map((conditionRule) => {
          const conditionField =
            conditionRule.conditionField && conditionRule.conditionField.value ? conditionRule.conditionField.value : conditionRule.conditionField;
          let conditionRuleOriginId = null;

          Object.values(oldSection.fields.items).forEach((element) => {
            if (conditionField === element.id) {
              conditionRuleOriginId = element.originId || element.id;
            }
          });

          if (conditionRuleOriginId) {
            Object.values(items).forEach((element) => {
              if (conditionRuleOriginId === element.originId) {
                conditionsRules.push(new FieldConditionRule({ ...conditionRule, conditionField: { value: element.id, label: element.label } }));
              }
            });
          } else {
            conditionsRules.push(new FieldConditionRule({ ...conditionRule }));
          }
        });
      }
      items = {
        ...items,
        [child.id]: new Field({
          ...child,
          conditions,
          conditionsRules
        })
      };
    });
    return new FieldList({ order, items });
  };

  _generateNewDataSection(fields) {
    const { fieldsData, unit, property, user } = this.state;

    let sectionData = {
      score: 0,
      fields: {},
      collapsed: false,
      visibility: true
    };

    const sectionErrors = {
      fields: {}
    };

    Object.values(fields.items).forEach((field) => {
      const value = this._getFieldDefaultValue(field, unit, property, user);
      const dataField = fieldsData ? fieldsData[field.id] : null;
      sectionData.fields[field.id] = {
        score: dataField ? dataField.score : null,
        value,
        photo: dataField ? dataField.photo : null,
        notes: dataField ? dataField.notes : null,
        chargesTriggers: dataField ? dataField.chargesTriggers : [],
        visibility: true
      };
      sectionErrors.fields[field.id] = dataField ? dataField.error : null;
    });

    return { sectionData, sectionErrors };
  }

  _insertChild = (order, sectionId, oldSectionId) => {
    let newOrder = [];
    order.map((section) => {
      newOrder.push(section);
      if (section === oldSectionId) {
        newOrder.push(sectionId);
      }
    });
    return newOrder;
  };

  onDeleteSectionCloned = (sectionId) => {
    let { configuration, fieldsData } = this.state;

    //Remove sectionId from order
    const newOrder = configuration.sections.order.filter((element) => element !== sectionId);

    //Remove section from data and configuration
    delete configuration.sections.items[sectionId];
    delete fieldsData.sections[sectionId];

    //Set new order to configuration
    configuration.sections.order = newOrder;

    // Update section score and total score
    fieldsData.score = this._getTotalScore(fieldsData, configuration);

    this.setState({
      configuration,
      fieldsData
    });
  };

  onOpenCreateWorkOrderTabs = (workOrderTabs) => {
    this.setState({ workOrderTabs });
  };

  onClickCreateNewWorkOrderTab = async (workOrderTabData) => {
    const { user, unit, workOrderTabs, property, fieldsData, configuration } = this.state;
    const { groupId, label, triggerId } = workOrderTabData;
    const { section, id } = this.getFieldData(groupId);
    const workOrderTriggers = fieldsData.sections[section].fields[id].workOrderTriggers || {};
    const tabWorkOrder = workOrderTabs[groupId] ? workOrderTabs[groupId][triggerId] || [] : [];
    let tabWorkOrdersNumber = workOrderTriggers[triggerId] ? workOrderTriggers[triggerId].work_orders.length : 0;
    tabWorkOrder.map((item) => {
      if (!item.id) {
        tabWorkOrdersNumber++;
      }
    });

    if (tabWorkOrdersNumber === 3) {
      NotificationService.notify('error', 'You cannot add more work-order-trigger for this field. The limit is 3.');
      return;
    }

    const data = {
      user,
      unit: unit ? unit.id : null,
      building: unit ? unit.building : null,
      groupId,
      triggerId,
      formDataId: fieldsData.id,
      label,
      property: property.id,
      account: property.account
    };

    if(data['unit']){
      data['requestedBy'] = unit.resident_name || (user ? `${user.first_name} ${user.last_name}` : null);
      data['phone'] = unit.resident_phone;
      data['email'] = unit.resident_email;
      if(property && property.pms_platform && property.pms_platform.code == 'entrata'){
        data['tenant_code'] = unit.resident_external_id;
      }
    }

    const workOrder = new WorkOrderModel(data);
    if (workOrder) {
      const newWorkOrderTab = !tabWorkOrder ? [workOrder] : [...tabWorkOrder, workOrder];
      const newWorkOrderTabs = {
        ...workOrderTabs,
        [groupId]: {
          ...workOrderTabs[groupId],
          [triggerId]: newWorkOrderTab
        }
      };
      const workOrderNumber = newWorkOrderTab.length <= 1 ? '' : `(${newWorkOrderTab.length})`;
      const field = configuration.sections.items[section].fields.items[id];
      const conditionLabel = getConditionLabel(field, triggerId);
      const tabLabel = `Work Order for ${label}: ${conditionLabel} ${workOrderNumber}`;
      this.setState({ workOrderTabs: newWorkOrderTabs, activeTab: tabLabel });
    }
  };

  onClickEditNewWorkOrderTab = async (workOrderTabData, groupId, triggerId, label) => {
    const { workOrderTabs, configuration, filters } = this.state;
    const { id } = workOrderTabData;
    const workOrderData = await WorkOrderTriggerService.getWorkOrderHidden(id, filters);
    let workOrder = await WorkOrderModel.parse(workOrderData);
    workOrder = { ...workOrder, groupId, triggerId, label };
    const tabWorkOrder = workOrderTabs[groupId] ? workOrderTabs[groupId][triggerId] : null;
    if (workOrder) {
      const fieldConfig = this.getFieldData(groupId);
      const field = configuration.sections.items[fieldConfig.section].fields.items[fieldConfig.id];
      let newWorkOrderTab = [];
      let edditing = null;
      if (!tabWorkOrder) {
        newWorkOrderTab = [workOrder];
      } else {
        tabWorkOrder.find((item, index) => {
          if (item.id == id) {
            edditing = index;
          }
        });
      }
      if (!Utils.isNull(edditing)) {
        const workOrderNumber = tabWorkOrder.length <= 1 ? '' : `(${edditing + 1})`;
        const conditionLabel = getConditionLabel(field, triggerId);
        const tabLabel = `Work Order for ${label}: ${conditionLabel} ${workOrderNumber}`;
        this.setState({ activeTab: tabLabel });
      } else {
        const oldTabWorkOrder = tabWorkOrder || [];
        newWorkOrderTab = [...oldTabWorkOrder, workOrder];
        const newWorkOrderTabs = {
          ...workOrderTabs,
          [groupId]: {
            ...workOrderTabs[groupId],
            [triggerId]: newWorkOrderTab
          }
        };
        const workOrderNumber = newWorkOrderTab.length <= 1 ? '' : `(${newWorkOrderTab.length})`;
        const conditionLabel = getConditionLabel(field, triggerId);
        const tabLabel = `Work Order for ${label}: ${conditionLabel} ${workOrderNumber}`;
        this.setState({ workOrderTabs: newWorkOrderTabs, activeTab: tabLabel });
      }
    }
  };

  onClickDeleteNewWorkOrderTab = async (index, groupId, triggerId) => {
    const { fieldsData, workOrderTabs, configuration, filters } = this.state;
    const { id, section } = this.getFieldData(groupId);
    const sectionData = { ...fieldsData.sections[section] };
    const fieldData = { ...sectionData.fields[id] };
    const { workOrderTriggers } = fieldData;
    const work_orders = workOrderTriggers[triggerId].work_orders;
    const tabWorkOrder = workOrderTabs[groupId] ? workOrderTabs[groupId][triggerId] : [];
    const params = {
      ...filters,
      field_group_id: groupId,
      trigger_id: triggerId,
      dynamic_form_data_id: fieldsData.id,
      trigger_type: 2,
      work_order_id: work_orders[index].id
    };
    const error = await DynamicFormDataService.removeTrigger(params);
    if (!error) {
      let newWorkOrderTab = [];
      let oldIndex = -1;
      tabWorkOrder.map((item, indexTab) => {
        if (item.id !== work_orders[index].id) {
          newWorkOrderTab.push(item);
        } else {
          oldIndex = indexTab;
        }
      });
      const newTab = newWorkOrderTab[oldIndex] || newWorkOrderTab[oldIndex - 1];
      const newWorkOrderTabs = {
        ...workOrderTabs,
        [groupId]: {
          ...workOrderTabs[groupId],
          [triggerId]: newWorkOrderTab
        }
      };
      let tabLabel = 'Dynamic Form';
      if (newTab) {
        const workOrderNumber = newWorkOrderTab.length <= 1 ? '' : `(${newWorkOrderTab.length})`;
        const field = configuration.sections.items[section].fields.items[id];
        const conditionLabel = getConditionLabel(field, triggerId);
        tabLabel = `Work Order for ${newTab.label}: ${conditionLabel} ${workOrderNumber}`;
      } else if (newWorkOrderTabs[groupId][triggerId].length === 0) {
        delete newWorkOrderTabs[groupId][triggerId];
        if (Object.keys(newWorkOrderTabs[groupId]).length === 0) {
          delete newWorkOrderTabs[groupId];
        }
      }
      this.setState({ workOrderTabs: newWorkOrderTabs, activeTab: tabLabel });
    }
    return error;
  };

  onSetTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  onCloseWorkOrderTab = (workOrderData, activeTab) => {
    const { groupId, time, triggerId } = workOrderData;
    const { workOrderTabs } = this.state;
    const newActiveTab = activeTab || 'Dynamic Form';
    let newWorkOrderTabs = _.cloneDeep(workOrderTabs);
    let oneWorkOrderInTrigger = newWorkOrderTabs[groupId] ? newWorkOrderTabs[groupId][triggerId]?.length === 1 : false;
    if (oneWorkOrderInTrigger) {
      delete newWorkOrderTabs[groupId][triggerId];
      let zeroWorkOrderInField = Object.keys(newWorkOrderTabs[groupId]).length === 0;
      if (zeroWorkOrderInField) {
        delete newWorkOrderTabs[groupId];
      }
    } else if (newWorkOrderTabs[groupId]) {
      newWorkOrderTabs[groupId][triggerId] = newWorkOrderTabs[groupId][triggerId].filter((item) => !moment(item.time).isSame(time));
    }
    if (this.state.activeTab !== 'Dynamic Form') {
      this.setState({ workOrderTabs: newWorkOrderTabs, activeTab: newActiveTab });
    } else {
      this.setState({ workOrderTabs: newWorkOrderTabs });
    }
  };

  getTargetWorkOrder = (newWorkOrderTabs, workOrderData) => {
    const { groupId, time, id, triggerId } = workOrderData;
    let pos;
    let targetWorkOrder = newWorkOrderTabs[groupId][triggerId].filter((item, index) => {
      if ((id && id === item.id) || moment(item.time).isSame(time)) {
        pos = index;
        return item;
      }
    })[0];
    return {
      targetWorkOrder,
      pos
    };
  };

  onSetWorkOrderFormData = (dataObj, workOrderData) => {
    const { groupId, triggerId } = workOrderData;
    const { workOrderTabs } = this.state;
    let newWorkOrderTabs = _.cloneDeep(workOrderTabs);
    let { pos, targetWorkOrder } = this.getTargetWorkOrder(newWorkOrderTabs, workOrderData);
    targetWorkOrder = {
      ...targetWorkOrder,
      ...dataObj
    };
    newWorkOrderTabs[groupId][triggerId][pos] = targetWorkOrder;
    this.setState({ workOrderTabs: newWorkOrderTabs });
  };

  saveDFChargeCodes = async (fieldsDataId, skipLoading) => {
    const { fieldsData, fieldsTrigger, configuration } = this.state;
    const results = [];
    for (let i = 0; i < configuration.sections.order.length; i++) {
      const section = configuration.sections.items[configuration.sections.order[i]];
      for (let j = 0; j < section.fields.order.length; j++) {
        const field = section.fields.items[section.fields.order[j]];
        const fieldData = fieldsData?.sections[section.id]?.fields[field.id];
        const oldTriggers = fieldsTrigger?.sections[section.id]?.fields[field.id] || [];
        if (fieldsDataId && fieldData) {
          const { chargesTriggers } = fieldData;
          // Remove ChargeCodeTriggers that are not met
          for (let j = 0; j < oldTriggers.length; j++) {
            const oldTrigger = oldTriggers[j];
            const triggerActive = chargesTriggers.filter((trigger) => trigger.id === oldTrigger.id);
            if (triggerActive.length === 0) {
              const params = {
                trigger_type: 3,
                charge_code_id: oldTrigger.charge_code_id,
                field_group_id: field.groupId,
                trigger_id: oldTrigger.id,
                dynamic_form_data_id: fieldsDataId
              };
              results.push(await DynamicFormDataService.removeTrigger(params, skipLoading));
            }
          }
          // Add or Update ChargeCodeTriggers
          for (let j = 0; j < chargesTriggers.length; j++) {
            const item = chargesTriggers[j];
            const triggerActive = oldTriggers.filter((trigger) => trigger.id === item.id);
            const { chargeCode } = item;
            const bodyData = {
              charge_code_id: chargeCode?.id || item.charge_code_id,
              amount: chargeCode?.default_amount || item.amount,
              comment: chargeCode?.comment || item.comment
            };
            const params = {
              trigger_type: 3,
              field_group_id: field.groupId,
              trigger_id: item.id,
              dynamic_form_data_id: fieldsDataId
            };
            if (triggerActive.length === 0) {
              results.push(await DynamicFormDataService.createTrigger(bodyData, params, skipLoading));
            } else {
              if ((triggerActive[0].amount !== bodyData.amount) || (triggerActive[0].comment !== bodyData.comment)) {
                results.push(await DynamicFormDataService.updateTrigger(bodyData, params, skipLoading));
              }
            }
          }
        }
      }
    }
    return results;
  };

  getFieldsVerbiage = (field, key) => {
    const { configuration } = this.state;
    if(this.state.availableLanguages && this.state.availableLanguages.length > 0){
      if(configuration.preview && field.previewLanguage && field[field.previewLanguage.code] && field[field.previewLanguage.code][key]){
        // if key is equal to options then default this 
      if(key == 'options'){
        return field[field.previewLanguage.code].options.map((item, index) => { return { value: index, label: item.label }; })
      }
      else if(key == 'defaultOptions'){
        return field[field.previewLanguage.code].options.map((item, index) => { return { value: item.label, label: item.label }; })
      }
        return field[field.previewLanguage.code][key];
      }
      else if(configuration.created_in_language && (field[configuration.created_in_language] && field[configuration.created_in_language][key] && (!Array.isArray(field[configuration.created_in_language][key]) || (Array.isArray(field[configuration.created_in_language][key]) && field[configuration.created_in_language][key].length > 0)))){
        // if key is equal to options then default this 
          if(key == 'options'){
            return field[configuration.created_in_language].options.map((item, index) => { return { value: index, label: item.label }; })
          }
          else if(key == 'defaultOptions'){
            return field[configuration.created_in_language].options.map((item, index) => { return { value: item.label, label: item.label }; })
          }
          return field[configuration.created_in_language][key];
      }
      //  return default for others
      else {
        if(key == 'options'){
          return field[key].map((item, index) => { return { value: index, label: item.value }; });
        }
        else if(key == 'defaultOptions'){
          return field['options'].map((item, index) => { return { value: item.value, label: item.value }; });
        }
        else {
          return field[key];
        }
      }
    }
    else {
      if(key == 'options'){
        return field[key].map((item, index) => { return { value: index, label: item.value }; });
      }
      else if(key == 'defaultOptions'){
        return field['options'].map((item, index) => { return { value: item.value, label: item.value }; });
      }
      else {
        return field[key];
      }
    }
    
  }
 // for updating the completing in language
  onCompleteInLanguage = (language) =>{
    const {configuration} = this.state;
    configuration.created_in_language = language;
    this.setState({configuration: {...configuration}});

  }

  render() {
    return <LfaContext.Provider value={this.state}>{this.props.children}</LfaContext.Provider>;
  }
}

export const LfaContextAPIShape = PropTypes.shape({
  init: PropTypes.func.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  onFieldErrorChange: PropTypes.func.isRequired,
  onFieldPhotoChange: PropTypes.func.isRequired,
  onFieldNotesChange: PropTypes.func.isRequired,
  getErrors: PropTypes.func.isRequired,
  convertToSaga: PropTypes.func.isRequired,
  getFirstError: PropTypes.func.isRequired,
  onSectionCollapsed: PropTypes.func.isRequired,
  onSaveCloneSection: PropTypes.func.isRequired,
  onDeleteSectionCloned: PropTypes.func.isRequired,
  getLabelGreatestSection: PropTypes.func.isRequired,
  setData: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  getConfigurationCopy: PropTypes.func.isRequired,
  onOpenCreateWorkOrderTabs: PropTypes.func.isRequired,
  onClickCreateNewWorkOrderTab: PropTypes.func.isRequired,
  onCloseWorkOrderTab: PropTypes.func.isRequired,
  onSetWorkOrderFormData: PropTypes.func.isRequired,
  getFieldsVerbiage : PropTypes.func.isRequired,
  onCompleteInLanguage : PropTypes.func.isRequired
});

export default LfaContext;
